import LoginView from './Login'
import OfflineView from './Offline'
import PageNotFoundView from './404'

export const Login = LoginView
export const Offline = OfflineView
export const PageNotFound = PageNotFoundView
